import { Typography, Box } from '@mui/material'

const NoGeoclaimCredits: React.FC<React.PropsWithChildren<unknown>> = () => (
  <Box textAlign="center" padding={4}>
    <Typography variant="h6" color="textSecondary">
      No geoclaim credits history found
    </Typography>
    <Typography variant="body2" color="textSecondary">
      Credit transactions will appear here once they are recorded
    </Typography>
  </Box>
)

export default NoGeoclaimCredits